import client, { mock, isRealApiEnabled } from "./client";

const seedAttributes = [
  {
    AttributeType: "Source",
    AttributeTypeCode: "SOURCE",
    Attributes: [
      { Attribute: "WWG", AttributeCode: "SOURCE_WWG", SortOrder: 1 },
      { Attribute: "3rd Party", AttributeCode: "SOURCE_3RD_PARTY", SortOrder: 2 },
    ],
  },
  {
    AttributeType: "Language",
    AttributeTypeCode: "LANGUAGE",
    Attributes: [
      { Attribute: "English", AttributeCode: "LANG_EN", SortOrder: 1 },
      { Attribute: "Spanish", AttributeCode: "LANG_ES", SortOrder: 2 },
      { Attribute: "Korean", AttributeCode: "LANG_KO", SortOrder: 3 },
    ],
  },
  {
    AttributeType: "Author",
    AttributeTypeCode: "AUTHOR",
    Attributes: [
      { Attribute: "John C. Maxwell", AttributeCode: "AUTHOR_MAXWELL", SortOrder: 1 },
      { Attribute: "Orrin Woodward", AttributeCode: "AUTHOR_WOODWARD", SortOrder: 2 },
      { Attribute: "Stephen R. Covey", AttributeCode: "AUTHOR_COVEY", SortOrder: 3 },
      { Attribute: "Jim Rohn", AttributeCode: "AUTHOR_ROHN", SortOrder: 4 },
      { Attribute: "Brian Tracy", AttributeCode: "AUTHOR_TRACY", SortOrder: 5 },
      { Attribute: "Simon Sinek", AttributeCode: "AUTHOR_SINEK", SortOrder: 6 },
      { Attribute: "Zig Ziglar", AttributeCode: "AUTHOR_ZIGLAR", SortOrder: 7 },
      { Attribute: "Dale Carnegie", AttributeCode: "AUTHOR_CARNEGIE", SortOrder: 8 },
      { Attribute: "Patrick Lencioni", AttributeCode: "AUTHOR_LENCIONI", SortOrder: 9 },
      { Attribute: "Robert Kiyosaki", AttributeCode: "AUTHOR_KIYOSAKI", SortOrder: 10 },
      { Attribute: "Napoleon Hill", AttributeCode: "AUTHOR_HILL", SortOrder: 11 },
      { Attribute: "Malcolm Gladwell", AttributeCode: "AUTHOR_GLADWELL", SortOrder: 12 },
      { Attribute: "Brené Brown", AttributeCode: "AUTHOR_BROWN", SortOrder: 13 },
      { Attribute: "James Clear", AttributeCode: "AUTHOR_CLEAR", SortOrder: 14 },
      { Attribute: "Carol Dweck", AttributeCode: "AUTHOR_DWECK", SortOrder: 15 },
      { Attribute: "Daniel Pink", AttributeCode: "AUTHOR_PINK", SortOrder: 16 },
      { Attribute: "Adam Grant", AttributeCode: "AUTHOR_GRANT", SortOrder: 17 },
      { Attribute: "Seth Godin", AttributeCode: "AUTHOR_GODIN", SortOrder: 18 },
      { Attribute: "Peter Drucker", AttributeCode: "AUTHOR_DRUCKER", SortOrder: 19 },
      { Attribute: "Tony Robbins", AttributeCode: "AUTHOR_ROBBINS", SortOrder: 20 },
    ],
  },
];

export function list(query) {
  if (isRealApiEnabled()) return client.get("/v1/attributes", { query: { q: query || "" } });
  const filtered = seedAttributes.map((attr) => ({
    ...attr,
    Attributes: query
      ? (attr.Attributes || []).filter((a) =>
          a.Attribute.toLowerCase().includes(query.toLowerCase())
        )
      : attr.Attributes,
  }));
  return mock(filtered);
}
